export const API_BASE = '/api/v1' as const;
